import { addTrack, getTracks } from "../../hooks/db";
import { useEffect } from "react";
import serverURL from "../../config/serverConfig";
import Comparator from "../player/Comparator";
import { CornerRightUp } from 'lucide-react';

import { useRef, useState } from "react";

const ALLOWED_AUDIO_EXTENSIONS = ['.mp3', '.wav', '.aac', '.mp4', '.m4a', '.aiff', '.aif', '.flac', '.ogg', '.oga', '.opus', '.weba'];

function isAllowedAudioFile(file) {
    if (!file) return false;
    if (file.type && file.type.startsWith('audio/')) return true;
    const ext = file.name.slice(file.name.lastIndexOf('.')).toLowerCase();
    return ALLOWED_AUDIO_EXTENSIONS.includes(ext);
}

function getKey(filename) {
  const extIndex = filename.lastIndexOf(".");

  //filname without extension
  const nameWithoutExt = extIndex !== -1 ? filename.slice(0, extIndex) : filename;
  
  // Handle files with no extension
  const ext = extIndex !== -1 ? filename.slice(extIndex) : "";
  
  // Generate a reasonably long random hash
  const randomKey = Math.random().toString(36).slice(2, 12) +
                     Math.random().toString(36).slice(2, 12);

  //return `${randomKey}${ext}`;
  //return filename with current date  and time then extension
    const now = new Date();
    const timestamp = now.toISOString().slice(0, 19).replace(/[-:]/g, "");
    return `${nameWithoutExt}_${timestamp}${ext}`;
}

const Tracks = (props) => {

    const fileInputRef = useRef(null);
    const [progress, setProgress] = useState(0);
    const [tracks, setTracks] = useState([]);
    const [latest, setLatest] = useState(null);
    const [fileChosen, setFileChosen] = useState(false);
    const [fileName, setFileName] = useState("");
    const [uploadComplete, setUploadComplete] = useState(false);
    const [isDragging, setIsDragging] = useState(false);

    useEffect(() => {
        const fetchTracks = async () => {
            const tracksData = await getTracks(props.project_id);
            setTracks(tracksData);
        };
        fetchTracks();
    }, [props.project_id, latest]);

    console.log("Current tracks:", tracks);

    const handleDragOver = (e) => {
        e.preventDefault();
        setIsDragging(true);
    };

    const handleDragLeave = (e) => {
        e.preventDefault();
        setIsDragging(false);
    };

    const handleDrop = (e) => {
        e.preventDefault();
        setIsDragging(false);

        const files = e.dataTransfer.files;
        if (!files.length) return;

        const file = files[0];
        if (!isAllowedAudioFile(file)) {
            alert("Please choose a valid audio file (MP3, WAV, AAC, M4A, AIFF, FLAC, OGG, etc).");
            return;
        }

        fileInputRef.current.files = files;
        setFileChosen(true);
        setFileName(file.name);
        setUploadComplete(false);
        setProgress(0);
    };

    const uploadTrack = async () => {
        const files = fileInputRef.current.files;

        if (!files.length) {
            alert("Please choose a file to upload first.");
            return;
        }

        const file = files[0];
        const uniqueKey = getKey(file.name);

        try {
            setProgress(0);
            setUploadComplete(false);

            // 👇 use your existing serverURL
            const res = await fetch(`${serverURL}upload-url`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify({
                key: uniqueKey,
                type: file.type,
            }),
            });

            const { url } = await res.json();

            // 👇 keep your progress bar working
            const xhr = new XMLHttpRequest();

            xhr.upload.onprogress = (event) => {
            if (event.lengthComputable) {
                const percent = Math.floor((event.loaded / event.total) * 100);
                setProgress(percent);
            }
            };

            xhr.open("PUT", url);
            xhr.setRequestHeader("Content-Type", file.type);

            await new Promise((resolve, reject) => {
            xhr.onload = resolve;
            xhr.onerror = reject;
            xhr.send(file);
            });

            const trackData = {
                project: props.project_id,
                key: uniqueKey,
                title: file.name,
                type: file.type,
                upload_date: new Date().toISOString(),
            };

            await addTrack(trackData);
            setLatest(uniqueKey);
            setUploadComplete(true);
            setTimeout(() => {
                setFileChosen(false);
                setFileName("");
                setUploadComplete(false);
                setProgress(0);
                fileInputRef.current.value = "";
            }, 8000);

        } catch (err) {
            console.error("UPLOAD ERROR:", err);
        }
    };
    console.log("Current tracks:", tracks);
    return (
        <div
            className={`tracks border border-dashed rounded-[7px] transition-colors duration-200 ${isDragging ? "border-blue-500" : "border-transparent"}`}
            onDragOver={handleDragOver}
            onDragLeave={handleDragLeave}
            onDrop={handleDrop}
        >
            <h5 className="blockHeader">MIXES</h5>
            {/* {props.project_id ? <p>Project ID: {props.project_id}</p> : <p>No project ID provided.</p>} */}
            <div id="uploadSection" className="flex flex-row justify-self-end text-xs p-2 rounded shadow-[#000000] shadow-md mb-5 mr-3 bg-[#101010]">
                <div>
                    <h5 className="uppercase font-semibold flex justify-center text-xs pb-2">Upload Mix</h5>

                    <input
                        type="file"
                        accept=".mp3,.wav,.aac,.mp4,.m4a,.aiff,.aif,.flac,.ogg,.oga,.opus,.weba,audio/*"
                        className="hidden"
                        ref={fileInputRef}
                        onChange={(e) => {
                            const file = e.target.files[0];
                            if (!isAllowedAudioFile(file)) {
                                alert("Please choose a valid audio file (mp3, wav, aac, m4a, aiff, flac, ogg, etc).");
                                e.target.value = "";
                                return;
                            }
                            setFileChosen(true);
                            setFileName(file.name);
                            setUploadComplete(false);
                            setProgress(0);
                        }}
                    />
                    <button
                        onClick={() => fileInputRef.current.click()}
                        className="bg-blue-600 hover:bg-blue-700 text-white font-bold py-1 px-2 rounded-md"
                    >
                        Choose File
                    </button>
                    {fileChosen && (
                        <>
                            <div className="mt-2 truncate text-gray-400">{fileName}</div>
                            <button
                                onClick={uploadTrack}
                                disabled={!fileChosen || uploadComplete}
                                className="bg-gray-700 hover:bg-blue-700 text-white font-bold py-1 px-2 rounded mt-2 disabled:opacity-40 disabled:cursor-not-allowed disabled:hover:bg-gray-700"
                            >
                                Upload
                            </button>
                            {!uploadComplete && (
                                <button
                                    onClick={() => {
                                        fileInputRef.current.value = "";
                                        setFileChosen(false);
                                        setFileName("");
                                        setProgress(0);
                                    }}
                                    className="bg-gray-700 hover:bg-red-700 text-white font-bold py-1 px-2 rounded ml-2 mt-2"
                                >
                                    Cancel
                                </button>
                            )}
                            <div style={{ width: "100%", maxWidth: "400px" }}>
                                <p>Progress: {progress}%</p>
                            </div>
                            <div
                                style={{
                                    width: "100%",
                                    height: "10px",
                                    backgroundColor: "#eee",
                                    borderRadius: "5px",
                                    overflow: "hidden",
                                }}
                            >
                                <div
                                    style={{
                                        width: `${progress}%`,
                                        height: "100%",
                                        backgroundColor: "#4caf50",
                                        transition: "width 0.2s ease",
                                    }}
                                />
                            </div>
                        </>
                    )}
                </div>
                
            </div>
            <div className="flex justify-self-center">
                <Comparator tracks={tracks} />
            </div>
            
            {tracks.length > 0 ? (
                <ul>
                    {/* {tracks.map((track) => (
                        <li key={track.key}>
                            {track.title} - Uploaded on {new Date(track.upload_date).toLocaleDateString()}
                        </li>
                    ))} */}
                </ul>
            ) : (
                <div className="justify-self-end mb-4 pr-12 uppercase text-sm flex flex-row items-center text-gray-400">
                    upload a mix
                    <div className="mb-3 ml-5 "><CornerRightUp /></div>
                </div>
            )}
        </div>
    )
}

export default Tracks;